import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import { useSelector } from 'react-redux';
import Skeletons from '@/components/Skeletons/Skeletons';
import styles from './dashboardMiniCards.module.scss';
import { useDndCardContext } from '../DndCard/context';

export default function MiniCard({
  title,
  value,
  children,
  onClick = null,
  loading = false,
}) {
  const { edition } = useSelector((state) => state.DashboardSlice);
  const { visible: dndVisible } = useDndCardContext();

  return (
    <Box
      className={`${styles.miniCard} ${
        onClick ? styles.miniCardClickable : ''
      }`}
      onClick={onClick}
      data-testid={onClick ? 'mini-card-clickable' : 'mini-card'}
    >
      {loading ? (
        <>
          <Skeletons height={16} width={220} borderRadius={16} />
          <Skeletons width={115} height={12} borderRadius={16} />
          <Skeletons width="100%" height={12} borderRadius={16} />
        </>
      ) : (
        <>
          <Box className={styles.miniCardHeader}>
            {edition.active && dndVisible && (
              <Icon
                className={styles.hiddenIcon}
                icon="icon-menu"
                fontSize="12px"
              />
            )}
            <Text className={styles.miniCardTitle}>{title}</Text>
          </Box>
          <Text className={styles.miniCardValue}>{value}</Text>
          {children}
        </>
      )}
    </Box>
  );
}
